import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { LinkSquare } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
interface ShipmentTrackingNumberProps {
  trackingNumber: string
  url?: string | null
}

export const ShipmentTrackingNumber = ({ trackingNumber, url }: ShipmentTrackingNumberProps) => {
  const handleRedirectInNewPage = () => {
    if (!url) return
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <HStack gap={1}>
      <Text color={colors.grey600}>{trackingNumber}</Text>
      {url && (
        <IconButton onClick={handleRedirectInNewPage} fontSize={15}>
          <LinkSquare color={colors.grey600} />
        </IconButton>
      )}
    </HStack>
  )
}
